  <template> 
   <div class="navBar"> 
    <div class="" :class="moveFlag ? 'nav' : 'navBox'" ref="nav"> 
     <ul class="navCon" :class="moveFlag ? 'navCon' : 'navBoxCon'"> 
      <li class="navCon_li3" @click="toHome()"> <img :src="moveFlag ? logoUrl1 : logoUrl2" class="nav_logo" /> </li> 
      <li class="navCon_li1" @mouseover="mouseOver(1)" @mouseleave="mouseLeave(1)"> 
       <div class="nav_a" :class="navIndex == 1 ? 'active' : ''">
        企业
       </div> 
       <div class="navCon_sel navSel"> 
        <div class="abotse"> 
         <div class="abotse_lf"> 
          <span class="abotse_sp" :class="abFlag == 1 ? 'active' : ''" @click="toIntro()">公司介绍 </span> 
          <span class="abotse_sp" :class="abFlag == 2 ? 'active' : ''" @click="toStory()">品牌故事 </span> 
          <span class="abotse_sp" :class="abFlag == 3 ? 'active' : ''" @click="toNews()">资讯中心 </span> 
          <span class="abotse_sp" :class="abFlag == 4 ? 'active' : ''" @click="toJoin()">加入我们 </span> 
          <span class="abotse_sp" :class="abFlag == 5 ? 'active' : ''" @click="toRelation()">投资者关系 </span> 
         </div> 
         <div class="abotse_rg"> 
          <div class="abotse_item" v-show="abFlag == 1"> 
           <div class="abotse_item_lf"> 
            <img src="~@/assets/image/nav/nav_pic1.jpg" class="nav_pic1" @click="toIntro()" /> 
           </div> 
           <div class="abotse_item_rg"> 
            <p class="abotse_rg_p">公司介绍</p> 
            <span class="abotse_more" @click="toIntro()">了解更多</span> 
           </div> 
          </div> 
          <div class="abotse_item" v-show="abFlag == 2"> 
           <div class="abotse_item_lf"> 
            <img src="~@/assets/image/nav/nav_pic3.jpg" class="nav_pic1" @click="toStory()" /> 
           </div> 
           <div class="abotse_item_rg"> 
            <p class="abotse_rg_p">品牌故事</p> 
            <span class="abotse_more" @click="toStory()">了解更多</span> 
           </div> 
          </div> 
          <div class="abotse_item" v-show="abFlag == 3"> 
           <div class="abotse_item_lf"> 
            <img src="~@/assets/image/nav/nav_pic4.jpg" class="nav_pic1" @click="toNews()" /> 
           </div> 
           <div class="abotse_item_rg"> 
            <p class="abotse_rg_p">资讯中心</p> 
            <span class="abotse_more" @click="toNews()">了解更多</span> 
           </div> 
          </div> 
          <div class="abotse_item" v-show="abFlag == 4"> 
           <div class="abotse_item_lf"> 
            <img src="~@/assets/image/nav/nav_pic5.jpg" class="nav_pic1" @click="toJoin()" /> 
           </div> 
           <div class="abotse_item_rg"> 
            <p class="abotse_rg_p">加入我们</p> 
            <span class="abotse_more" @click="toJoin()">了解更多</span> 
           </div> 
          </div> 
          <div class="abotse_item" v-show="abFlag == 5"> 
           <div class="abotse_item_lf"> 
            <img src="~@/assets/image/nav/nav_pic2.jpg" class="nav_pic1" @click="toRelation()" /> 
           </div> 
           <div class="abotse_item_rg"> 
            <p class="abotse_rg_p">投资者关系</p> 
            <span class="abotse_more" @click="toRelation()">了解更多</span> 
           </div> 
          </div> 
         </div> 
        </div> 
       </div> </li> 
      <li class="navCon_li2" @mouseover="mouseOver(2)" @mouseleave="mouseLeave(2)"> 
       <div class="nav_a">
        产品
       </div> 
       <div class="navCon_sel2 navSel"> 
        <div class="lxcpBox"> 
         <div class="lxcpBox_hd"> 
          <span v-for="(item, key) in data" :key="key" class="lxcpBox_tab_li" :class="actIndex2 == key ? 'active' : ''" @click="tabClick2(key)">{{ item.name }}</span> 
         </div> 
        </div> 
        <div class="lxcpBox_bd"> 
         <div class="abotse" v-show="actIndex2 == key" v-for="(item, key) in data" :key="key"> 
          <div class="abotse_lf"> 
           <span v-for="(val, ks) in item.product" :key="ks" class="abotse_sp" :class="wmIndex == ks ? 'active' : ''" @click="wmClick(ks)"> {{ val.name }} </span> 
          </div> 
          <div class="abotse_rg2"> 
           <div v-for="(val, ks) in item.product" :key="ks" class="abotse_item" v-show="wmIndex == ks"> 
            <div v-if="item.id != 5"> 
             <div class="abotse_item_in" @click="toproduct(val.id)"> 
              <div class="abotse_item_in_car"> 
               <div class="abls_abset"> 
                <img :src="val.thumb" class="xiala_pic" /> 
                <p class="abotse_item_in_p3">{{ val.name }}</p> 
               </div> 
               <img :src="val.pic" class="car01" /> 
               <p class="abotse_item_in_p">{{ val.name }}</p> 
              </div> 
             </div> 
            </div> 
            <div v-else=""> 
             <!-- 大中面信息写死 --> 
             <div class="abotse_item_in" @click="toproduct(val.id)" style="display: flex; justify-content: center"> 
              <div class="abotse_item_in_car"> 
               <div class="abls_abset" > 
                <img :src="val.thumb" class="xiala_pic" /> 
                <p class="abotse_item_in_p3">{{ val.name1 }}</p> 
               </div> 
               <img :src="val.pic" class="car01"  /> 
               <p class="abotse_item_in_p">{{ val.name1 }}</p> 
              </div> 
              <div class="abotse_item_in_car"> 
               <div class="abls_abset" > 
                <img :src="val.thumb2" class="xiala_pic" /> 
                <p class="abotse_item_in_p3">{{ val.name2 }}</p> 
               </div> 
               <img :src="val.pic2" class="car01" /> 
               <p class="abotse_item_in_p">{{ val.name2 }}</p> 
              </div> 
             </div> 
            </div> 
           </div> 
          </div> 
         </div> 
        </div> 
       </div> </li> 
      <li class="navCon_li4" @mouseover="mouseOver(3)" @mouseleave="mouseLeave(3)"> 
       <div class="nav_a">
        服务
       </div> 
       <div class="navCon_sel4 navSel"> 
        <div class="abotse"> 
         <div class="abotse_lf"> 
          <span class="abotse_sp" :class="fwFlag == 1 ? 'active' : ''" @click="toDealer()">菱势线下体验店 </span> 
          <span class="abotse_sp" :class="fwFlag == 2 ? 'active' : ''" @click="toSupplier()">特约服务站及电池回收网点 </span> 
          <span class="abotse_sp" :class="fwFlag == 3 ? 'active' : ''" @click="toService()">大客户购车 </span> 
         </div> 
         <div class="abotse_rg"> 
          <div class="abotse_item" v-show="fwFlag == 1"> 
           <div class="abotse_item_lf"> 
            <img src="~@/assets/image/nav/fw_pic3.jpg" class="nav_pic1" @click="toDealer()" /> 
           </div> 
           <div class="abotse_item_rg"> 
            <p class="abotse_rg_p">菱势线下体验店</p> 
            <span class="abotse_more" @click="toDealer()">了解更多</span> 
           </div> 
          </div> 
          <div class="abotse_item" v-show="fwFlag == 2"> 
           <div class="abotse_item_lf"> 
            <img src="~@/assets/image/nav/fw_pic2.jpg" class="nav_pic1" @click="toSupplier()" /> 
           </div> 
           <div class="abotse_item_rg"> 
            <p class="abotse_rg_p">特约服务站</p> 
            <span class="abotse_more" @click="toSupplier()">了解更多</span> 
           </div> 
          </div> 
          <div class="abotse_item" v-show="fwFlag == 3"> 
           <div class="abotse_item_lf"> 
            <img src="~@/assets/image/nav/fw_pic1.jpg" class="nav_pic1" @click="toService()" /> 
           </div> 
           <div class="abotse_item_rg"> 
            <p class="abotse_rg_p">大客户购车</p> 
            <span class="abotse_more" @click="toService()">了解更多</span> 
           </div> 
          </div> 
         </div> 
        </div> 
       </div> </li> 
      <li class="navCon_li5" @mouseover="mouseOver(4)" @mouseleave="mouseLeave(4)"> 
       <div class="nav_a">
        了解更多
       </div> 
       <div class="navCon_sel5 navSel"> 
        <div class="abotse"> 
         <div class="abotse_lf"> 
          <span class="abotse_sp" :class="moFlag == 1 ? 'active' : ''" @click="toCooperate()">加盟合作 </span> 
          <span class="abotse_sp" :class="moFlag == 2 ? 'active' : ''" @click="tocontact()">联系我们 </span> 
          <span class="abotse_sp" :class="moFlag == 3 ? 'active' : ''" @click="toSer()">服务支持 </span> 
         </div> 
         <div class="abotse_rg"> 
          <div class="abotse_item" v-show="moFlag == 1"> 
           <div class="abotse_item_lf"> 
            <img src="~@/assets/image/nav/lj_pic2.jpg" class="nav_pic1" @click="toCooperate()" /> 
           </div> 
           <div class="abotse_item_rg"> 
            <p class="abotse_rg_p">加盟合作</p> 
            <span class="abotse_more" @click="toCooperate()">了解更多</span> 
           </div> 
          </div> 
          <div class="abotse_item" v-show="moFlag == 2"> 
           <div class="abotse_item_lf"> 
            <img src="~@/assets/image/nav/lj_pic3.jpg" class="nav_pic1" @click="tocontact()" /> 
           </div> 
           <div class="abotse_item_rg"> 
            <p class="abotse_rg_p">联系我们</p> 
            <span class="abotse_more" @click="tocontact()">了解更多</span> 
           </div> 
          </div> 
          <div class="abotse_item" v-show="moFlag == 3"> 
           <div class="abotse_item_lf"> 
            <img src="~@/assets/image/nav/lj_pic1.jpg" class="nav_pic1" @click="toSer()" /> 
           </div> 
           <div class="abotse_item_rg"> 
            <p class="abotse_rg_p">服务支持</p> 
            <span class="abotse_more" @click="toSer()">了解更多</span> 
           </div> 
          </div> 
         </div> 
        </div> 
       </div> </li> 
      <li class="navCon_li3" @click="toHome()"> <img :src="moveFlag ? logoUrl4 : logoUrl3" class="nav_logo" /> </li> 
     </ul> 
    </div> 
    <!-- <div class="navZhan"></div>--> 
   </div> 
  </template> 
  <script>
import { isCardName, isEmailAvailable } from "@/untils/tool.js";
import { Toast } from "vant";
import { mapMutations, mapGetters, mapState } from "vuex";
import Swiper from "swiper";
import "swiper/dist/css/swiper.min.css";
import "swiper/dist/js/swiper.min.js";
export default {
  name: "",
  data() {
    return {
      wmIndex: 0,
      wmIndex2: 0,
      fwFlag: 1,
      moFlag: 1,
      abFlag: 1,
      navIndex: 4,
      moveFlag: false,
      actIndex2: 0,
      mySwiper2: null,
      bannerList: [],
      scrollTop: 0,
      h2: 0,
      logoUrl1: require("@/assets/image/logo1.png"),
      logoUrl2: require("@/assets/image/logo2.png"),
      logoUrl3: require("@/assets/image/nav/rightlogob.png"),
      logoUrl4: require("@/assets/image/nav/rightlogo.png"),
      tabList2: [
        {
          name: "混动小卡",
        },
        {
          name: "微卡",
        },
        {
          name: "微面",
        },
        {
          name: "冷藏车",
        },
      ],
      nav: [],
      data: [],
    };
  },
  watch: {},
  computed: {
    ...mapState(["langFlag", "lang"]),
  },
  mounted() {
    let that = this;

    this.$post("/api/nav", {
      platform: "pc",
    }).then((resp) => {
      if (resp.code == 1) {
        var data = [];
        resp.data.forEach((element) => {
          this.nav.push({
            name: element.name,
          });

          if (element.id == 5) {
            element.product.map((item) => {
              // 每个产品，加一个名称和图片
              if (item.id == 8) {
                  item.thumb2 =
                  "/imgHost/1751271439557cang45h.png";
                item.name2 = "黄金仓（货运版）";
                item.name1 = "黄金仓（客车版）";
                item.pic2 =
                  "/imgHost/1751271426696cang9h.png";
              } else if (item.id == 15) {
                item.thumb2 = "/imgHost/1751271643020plus45h.png";
                item.name2 = "黄金仓PLUS（货运版）";
                item.name1 = "黄金仓PLUS（客车版）";
                item.pic2 = "/imgHost/1751271727556plus9h.png";
              }
            });
          }
          else if (element.id == 1) {
               
                element.product.map((item)=>{if(item.id == 14){item.name ="黄金小卡· 超值版";
              }
            });
          }

          data.push(element);
        });

        this.data = data;
      }
    });

    // 滚动条滚动
    window.addEventListener("scroll", this.handleScroll);
  },
  methods: {
    wmClick(num) {
      this.wmIndex = num;
    },
    wmClick2(num) {
      this.wmIndex2 = num;
    },
    fwClick(num) {
      this.fwFlag = num;
    },
    abClick(num) {
      this.abFlag = num;
    },
    moClick(num) {
      this.moFlag = num;
    },
    handleScroll() {
      // 页面滚动距顶部距离
      this.scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      this.h2 = this.$refs.nav.offsetHeight;
      console.log("hhh", this.scrollTop, this.h2);
      if (this.scrollTop < this.h2) {
        this.moveFlag = false;
      } else {
        this.moveFlag = true;
      }
    },
    tabClick2(index) {
      this.actIndex2 = index;
    },
    mouseOver(num) {
      this.navIndex = num;
      if (this.scrollTop == 0) {
        this.moveFlag = true;
      }
    },
    mouseLeave(num) {
      this.navIndex = 0;
      if (this.scrollTop == 0) {
        this.moveFlag = false;
      }
    },
    toHome() {
      this.$router.push({
        name: "home",
        query: {},
      });
    },
    toIntro() {
      this.$router.push({
        name: "introduce",
        query: {},
      });
    },
    toRelation() {
      this.$router.push({
        name: "relation1",
        query: {},
      });
    },
    toStory() {
      this.$router.push({
        name: "story",
        query: {},
      });
    },
    toproduct(id) {
      this.$router.push({
        name: "product1",
        query: {
          id: id,
        },
      });

      // this.$router.go(0)
    },
    toNews() {
      this.$router.push({
        name: "news1",
        query: {},
      });
    },
    toConsultation() {
      this.$router.push({
        name: "consultation",
        query: {},
      });
    },
    toCooperate() {
      this.$router.push({
        name: "cooperate",
        query: {},
      });
    },
    tocontact() {
      this.$router.push({
        name: "contactUs",
        query: {},
      });
    },

    toService() {
      this.$router.push({
        name: "service",
        query: {},
      });
    },
    toJoin() {
      this.$router.push({
        name: "join",
        query: {},
      });
    },
    toSer() {
      this.$router.push({
        name: "ser",
        query: {},
      });
    },
    toproduct1() {
      this.$router.push({
        name: "product1",
        query: {},
      });
    },
    toproduct2() {
      this.$router.push({
        name: "product2",
        query: {},
      });
    },
    toproduct3() {
      this.$router.push({
        name: "product3",
        query: {},
      });
    },
    toproduct4() {
      this.$router.push({
        name: "product4",
        query: {},
      });
    },
    toDemo() {
      this.$router.push({
        name: "demo",
        query: {},
      });
    },
    toNothig() {
      this.$router.push({
        name: "demo",
        query: {},
      });
    },
    toDealer() {
      this.$router.push({
        name: "dealer",
        query: {},
      });
    },
    toSupplier() {
      this.$router.push({
        name: "supplier",
        query: {},
      });
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/nav.vue